import '@wrenpages/design-system/styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import type { DataRouter } from 'react-router';
import { App } from './app/App';
import { createRouter } from './app/router';

const container = document.getElementById('root');
if (!container) throw new Error('#root not found in index.html');

/** Resolves once the lazy route for the current URL is loaded. */
const whenReady = (router: DataRouter) =>
  new Promise<void>((resolve) => {
    if (router.state.initialized) return resolve();
    const unsubscribe = router.subscribe((state) => {
      if (state.initialized) {
        unsubscribe();
        resolve();
      }
    });
  });

const router = createRouter();
// The HTML already holds the pre-rendered page; swap in the live app only when it can render the same route,
// so visitors never see an empty frame.
await whenReady(router);

createRoot(container).render(
  <StrictMode>
    <App router={router} />
  </StrictMode>,
);
